import { render, staticRenderFns } from "./RoomDescriptionItem.vue?vue&type=template&id=61a1da28&scoped=true"
import script from "./RoomDescriptionItem.vue?vue&type=script&lang=ts"
export * from "./RoomDescriptionItem.vue?vue&type=script&lang=ts"
import style0 from "./RoomDescriptionItem.vue?vue&type=style&index=0&id=61a1da28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1da28",
  null
  
)

export default component.exports